import React from 'react';
import ReleaseNote from './release-notes-detailed';

export default function render(entry) {
    return <ReleaseNote entry={entry} />;
}
